import Vue from 'vue';

import { AppError, HttpError } from '@/models/app-error';

export class ApiClient {
    
    // Constructor

    constructor(baseUrl, store, router) {
        this.baseUrl = baseUrl;
        this.store = store;
        this.router = router;
    }

    // Public methods

    async get(url, params, options) {        
        var config = this.createRequestConfig({
            method: 'get',
            url: url,
            params: params,
            options: options
        });

        return await this.executeRequest(config);
    }

    async post(url, data, options) {
        var config = this.createRequestConfig({
            method: 'post',
            url: url,
            data: data,
            options: options
        });
        
        return await this.executeRequest(config);
    }

    async put(url, data, options) {
        var config = this.createRequestConfig({
            method: 'put',
            url: url,
            data: data,
            options: options
        });

        return await this.executeRequest(config);
    }

    async delete(url, data, options) {
        var config = this.createRequestConfig({
            method: 'delete',
            url: url,
            data: data,
            options: options
        });

        return await this.executeRequest(config);
    }    

    // Private methods

    createRequestConfig(requestConfig) {
        var config = {
            baseURL: this.baseUrl,
            url: requestConfig.url,
            method: requestConfig.method
        };

        if (requestConfig.params) config.params = requestConfig.params;
        if (requestConfig.data) config.data = requestConfig.data;

        config.anonymous = requestConfig.options && requestConfig.options.anonymous;
        if (!config.anonymous) {
            config.headers = { "Authorization" : `Bearer ${this.store.state.session.token}` }; 
        }        

        return config;
    } 

    async executeRequest(config) {
        try {
            const response = await Vue.axios.request(config);
            if (response.data.isSuccess === false) throw { response: response };            
            return response.data;

        } catch (error) {
            this.handleError(error, config);                       
        }
    }

    handleError(error, config) {    
        if (error && error.response && error.response.status === 401 && !config.anonymous) { 
            // Unauthorized response received     
            this.store.dispatch('session/reset'); 
            this.router.push({ name: 'Login' });

            return;
        }

        throw new AppError(HttpError, error.message, error.response);            
    }
   
}